module.exports = __webpack_public_path__ + "static/media/PullUpsFemale.1063498e.svg";